/* eslint-disable camelcase */
import api from '@/api'

export default {
  data() {
    return {
      timer: null,
      timeSpent: 0,
    }
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        this.timeSpent += 1
      }, 1000)
    },
    stopTimer() {
      clearTimeout(this.timer)
      this.saveDataAsync({})
    },
    saveDataAsync({ score = 3 }) {
      const { session_id } = this.$route.query
      api.saveResultsBackground({
        score,
        session_id,
        time_spent: this.timeSpent,
      })
    },
    saveData({ score = 3 }) {
      const { session_id } = this.$route.query
      api.saveResults({
        session_id,
        time_spent: this.timeSpent,
        score,
      })
    },
  },
  beforeDestroy() {
    this.stopTimer()
  },
}
